
import { QueryClient, QueryClientProvider, QueryCache } from "@tanstack/react-query";
import { ReactNode } from "react";

// Optimized client for weak devices
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1, // Reduce retries for faster failure
      staleTime: 5 * 60 * 1000, // Keep data fresh for 5 minutes
      gcTime: 15 * 60 * 1000, // Keep cache for 15 minutes
      refetchOnWindowFocus: false,
      refetchOnMount: false, // Don't refetch on mount by default
      refetchOnReconnect: 'always',
      networkMode: 'online' // Only run queries when online
    },
    mutations: {
      retry: 1,
      networkMode: 'online'
    }
  },
  // Override settings for specific query types
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Special handling for settings queries
      if (query.queryKey?.[0] === 'indexSettings') {
        console.error('Settings query error:', error);
      }
    },
  }),
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
